import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import Uniform from './uniform.jsx';

export default class ThisDriversArchivedUniforms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      url: props.url || '/api/v1/portal/drivers/uniforms',
      uniformAccountId: props.uniformAccountId || null,
    };
  }

  componentDidMount() {
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/uniforms/'+
      this.state.uniformAccountId+'/archived',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(uniformsJson) {
      that.setState({
        uniforms: uniformsJson,
        isLoading: false
      });
    });
  }

  render() {
    var Uniforms = [];

    if (this.state.uniforms && this.state.uniforms.length > 0) {
      this.state.uniforms.forEach(function(i) {
          Uniforms.push(<Uniform key={'uniform-'+i.id} data={i} />);
        });
    }
    return (
        <div>
            <div className="row uniforms-table-header">
                <div className="col-md-3">
                    description
                </div>
                <div className="col-md-3">
                    reference
                </div>
                <div className="col-md-2">
                    amounts
                </div>
                <div className="col-md-2">
                    frequency
                </div>
                <div className="col-md-2">
                    details
                </div>
            </div>
            {Uniforms}
        </div>
    );
  }
}
